import "./adminHome.css";
import React from "react";
import { db, storage} from "../../Firebase";
import { collection } from "firebase/firestore";
import { addDoc } from "firebase/firestore";
import {ref,uploadBytes, getDownloadURL} from "firebase/storage";
import Book from "./Book";

export default function Adminhome() {

    const [formData, setFormData] = React.useState({
        title: '',  
        author: '',
        bookimg: '',
        audioFiles: [] 
    });
    

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "audioFiles") {
            setFormData(prev => ({
                ...prev,
                [name]: Array.from(files) // multiple files
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };
    

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        try {
            const chapterURLs = [];
    
            for (let file of formData.audioFiles) {
                const audioRef = ref(storage, `audio/${file.name}`);
                await uploadBytes(audioRef, file);
                const url = await getDownloadURL(audioRef);
                chapterURLs.push({ name: file.name, url });
            }
    
            const docData = {
                title: formData.title,
                author: formData.author,
                bookimg: formData.bookimg,
                chapters: chapterURLs  // instead of just one audioFile
            };
    
            await addDoc(collection(db, "books"), docData);
            alert("Book added successfully");
            console.log("Book added successfully");
    
            setFormData({
                title: '',
                author: '',
                bookimg: '',
                audioFiles: []
            });
    
        } catch (err) {
            console.error("Error adding book: ", err);
        }
    };
    

return (
    <>  
     <div className="background-home">
        <div className="header">
          <div className="left-section">
            <img
              className="logo-img"
              src="lilable.png" 
              alt="Logo"
            />
        
          </div>
          <div className="right-section">
            <img src="https://img.icons8.com/ios7/512/search.png" alt="magnify" className='search-btn'/>
          </div>
        </div>
        {/* Scrollable content below */}
        <div className="home-content-admin">
            <h1 className='admin-h1'>Hello Nick</h1>
        <br />
        <form onSubmit={handleSubmit}>
        <input className="admin-input" type="text" name="title" placeholder="title" value={formData.title} onChange={handleChange}/>
        <input className="admin-input" type="text" name="author" placeholder="author" value={formData.author} onChange={handleChange}/>
        <input className="admin-input" type="url" name="bookimg" placeholder="book image url" alt="Book-img" value={formData.bookimg} onChange={handleChange}/>
        <input
            className="admin-file"
            type="file"
            name="audioFiles"
            multiple
            onChange={handleChange}
        />

        <button type="submit" className="admin-btn" onClick={console.log("submitting...")}>Submit</button>
            
        </form>
        <h1>Published Lilables:</h1>
        <div className="book-grid">
           
            <Book />
                    </div>

        </div>

        </div>
    
    </>
)

}